<template>
  <div class="deviceInfo">
    <commonHeader title="设备信息数据统计" :isMore="false"></commonHeader>
    <section class="device_statis">
      <img src="../img/statis_bg.png" class="statis_bg" />
      <div class="statis_container">
        <div class="statis_title">设备统计</div>
        <div class="statis_content">
          <deviceCharts :chartData="deviceAlarmData" id="videoAlarmPie" />
          <div class="device_total">
            <span class="title">设备总数</span>
            <span class="total">{{ deviceAlarmTotal }}<em>个</em></span>
          </div>
          <ul class="percent_con">
            <li v-for="(item, index) in percentData" :key="index">
              <div class="percent_con_left">
                <span class="mark" :style="{ background: item.color }"></span>
                <span class="name">{{ item.name }}</span>
              </div>
              <div class="percent_con_right">
                <span class="count">{{ item.value }}</span>
                <span class="percent">{{ item.percent }}%</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="alarm_statis">
      <div class="statis_title">告警统计</div>
      <div class="alarm_charts" v-if="isHasData">
        <alarmCharts :chartData="alarmData" id="alarmBar" />
      </div>
      <div class="alarm_charts" v-else>
        <div class="no-data">暂无数据</div>
      </div>
    </section>
  </div>
</template>

<script>
  import commonHeader from '../commonHeader'
  import alarmCharts from './alarmCharts'
  import deviceCharts from './deviceCharts'
  export default {
    components: {
      commonHeader,
      alarmCharts,
      deviceCharts
    },
    data() {
      return {
        deviceAlarmData: {
          data: []
        },
        percentData: [],
        alarmData: {
          xAxis: [],
          yAxis: {
            data: []
          }
        },
        isHasData: false,
        deviceAlarmTotal: 0,
        refreshTime: null
      }
    },
    mounted() {
      this.getDeviceInfo()
      this.getAlarmInfo()
      this.refreshTime = setInterval(() => {
        this.getDeviceInfo()
        this.getAlarmInfo()
      }, 5 * 60 * 1000)
    },
    methods: {
      getDeviceInfo() {
        this.$axiosget('operation/gapStick/dataStatistics').then(res => {
          if (res.data.status == 10000) {
            let data = [
              {
                name: '设备正常数量',
                value: 0
              },
              {
                name: '设备离线数量',
                value: 0
              }
            ]
            data.forEach(item => {
              if (item.name == '设备正常数量') {
                item.value = res.data.data.normalCount
              } else if (item.name == '设备离线数量') {
                item.value = res.data.data.offlineCount
              }
            })
            this.deviceAlarmData.data = data
            this.deviceAlarmTotal = res.data.data.total

            let cloneData = [
              {
                name: '设备正常数量',
                value: 0
              },
              {
                name: '设备报警数量',
                value: 0
              },
              {
                name: '设备离线数量',
                value: 0
              },
              {
                name: '线路报警数量',
                value: 0
              }
            ]
            cloneData.forEach(item => {
              if (item.name == '设备正常数量') {
                item.value = res.data.data.normalCount
                item.percent =
                  this.deviceAlarmTotal > 0
                    ? ((res.data.data.normalCount / this.deviceAlarmTotal) * 100).toFixed(2)
                    : 0
                item.color = '#5eaeff'
              } else if (item.name == '设备报警数量') {
                item.value = res.data.data.alarmCount
                item.percent =
                  this.deviceAlarmTotal > 0
                    ? ((res.data.data.alarmCount / this.deviceAlarmTotal) * 100).toFixed(2)
                    : 0
                item.color = '#39d9d6'
              } else if (item.name == '设备离线数量') {
                item.value = res.data.data.offlineCount
                item.percent =
                  this.deviceAlarmTotal > 0
                    ? ((res.data.data.offlineCount / this.deviceAlarmTotal) * 100).toFixed(2)
                    : 0
                item.color = '#ff7538'
              } else if (item.name == '线路报警数量') {
                item.value = res.data.data.wireAlarmCount
                item.percent = ((res.data.data.wireAlarmCount / 8) * 100).toFixed(2)
                item.color = '#f0ca87'
              }
            })

            this.percentData = cloneData
          }
        })
      },
      getAlarmInfo() {
        this.$axiosget('operation/gapStick/alarmStatistics').then(res => {
          if (res.data.status == 10000) {
            let objData = {
              currentValue: '线路电流',
              electric: '主机电量',
              temperature: '环境温度',
              humidity: '环境湿度',
              scope: '舞动幅度',
              frequency: '舞动频率',
              lineTemperature: '线路温度'
            }
            if (res.data.data.length > 0) {
              this.isHasData = true
            }
            this.alarmData.yAxis.data = res.data.data.map(item => item.count)
            this.alarmData.xAxis = res.data.data.map(item => objData[item.dataFlag])
          }
        })
      }
    },
    beforeDestroy() {
      if (this.refreshTime) {
        clearInterval(this.refreshTime)
      }
      this.refreshTime = null
    }
  }
</script>

<style lang="less" scoped>
  .deviceInfo {
    position: relative;
    height: 100%;

    & > section {
      margin: 0 0.23rem;
      position: relative;

      .statis_title {
        width: 0.29rem;
        height: 11.68vh;
        background-color: #1cbdff;
        border-radius: 0 0.17rem 0.17rem 0;
        font-family: AdobeHeitiStd-Regular;
        font-size: 1.67vh;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        writing-mode: vertical-rl;
        text-orientation: upright;
        letter-spacing: 0.05rem;
      }
    }

    .device_statis {
      height: 20.66vh;
      margin-top: 7.88vh;

      .statis_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 12.6vh;
        z-index: 1;
      }

      .statis_container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;

        .statis_content {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;

          .device_total {
            position: absolute;
            right: 6%;
            top: 1.57vh;
            width: 2.12rem;
            height: 3.98vh;
            background-image: url('../img/alarm_total.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding-left: 0.67rem;
            padding-bottom: 0.43vh;
            display: inline-flex;
            justify-content: space-between;
            align-items: center;

            .title {
              font-family: 'HiraginoSansGB-W3';
              font-size: 1.11vh;
              line-height: 1;
              color: rgba(255, 255, 255, 0.8);
            }

            .total {
              font-family: 'YouSheBiaoTiHei';
              font-size: 2.22vh;
              line-height: 1;
              color: #fff;
              em {
                font-family: 'HiraginoSansGB-W3';
                font-size: 1.11vh;
                line-height: 1;
                color: rgba(255, 255, 255, 0.8);
                margin: 0 0.06rem;
              }
            }
          }

          .percent_con {
            position: absolute;
            right: 0.35rem;
            top: 35%;
            font-family: HiraginoSansGB-W3;
            font-size: 1.11vh;
            color: #fff;

            li {
              display: flex;
              justify-content: space-between;
              align-items: center;

              &:not(:last-child) {
                margin-bottom: 1.67vh;
              }
            }

            &_left {
              margin-right: 0.52rem;
              display: flex;
              align-items: center;
              .mark {
                display: inline-block;
                width: 0.1rem;
                height: 0.1rem;
                margin-right: 0.09rem;
              }
            }

            &_right {
              width: 0.75rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
        }
      }
    }

    .alarm_statis {
      height: calc(100% - 20.66vh - 7.88vh);
      background: url('../img/alarm_statis.png') no-repeat;
      background-size: 100% 100%;

      .statis_title {
        background: #39d9d6;
      }

      .alarm_charts {
        position: absolute;
        top: 0;
        left: 0.32rem;
        right: 0;
        bottom: 0;
        height: 100%;
      }

      .no-data {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.3vh;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/deviceInfo.vue